var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "communication / 16 - communication, bubble, chat, comments, conversation, message icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Free-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1265.000000, -156.000000)",
    id: "Group",
    stroke: "white",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1263.000000, 154.000000)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.29997591,16.1586109 L4.71,18.3 L5.32628923,14.6238888 C3.83281239,13.3921212 3,11.6856969 3,9.8 C3,6.0444637 6.30329488,3 11.55,3 C16.7967051,3 20.1,6.0444637 20.1,9.8 C20.1,13.5555363 16.7967051,16.6 11.55,16.6 C10.3617053,16.6 9.27309774,16.4438342 8.29997591,16.1586109 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7000346,12 C20.5370398,12.8311353 21,13.932301 21,15.1401596 C21,16.4401458 20.4637233,17.6165428 19.5020218,18.4657147 L19.8988718,21 L17.587162,19.5237413 C16.9605351,19.7203723 16.259543,19.8280319 15.4943589,19.8280319 C12.7385072,19.8280319 10.8153028,18.4315592 10.2,16.5116586 L10.2,16.5116586"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat-icon.4f906ec451bdcbe91cb1ebc4204d214e.svg";
export { ForwardRef as ReactComponent };